import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { Link } from 'react-router-dom';

const MultiBookingInformation = (props) => {
    const { data, translate } = props;

    if (utils.isEmpty(data)) {
        return null;
    }

    /**
     * When split_from AND split_to are not filled,
     * then we return null;
     */
    if (!data.split_from && !data.split_to) {
        return null;
    }

    let result;

    /**
     * When the split_from is filled, we can asume this is a splitted booking.
     * Then we display the id of the parent booking.
     */
    if (data.split_from) {
        result = (
            <div>
                <span>{ translate('resources.orders.information.multibookings.split_from') }</span>
                <Link to={ `/orders/${ data.split_from }/show` }>
                    { data.split_from }
                </Link>
            </div>
        );
    }

    /**
     * When the split_to is filled, we can asume this is a splitted booking.
     * Then we display the id of the parent booking.
     *
     * Note:
     * The reduce is only usefull when we have more then one value,
     * because reduce() without second argument will throw with an empty array.
     * In the case of split_to we will always have a minimal of 2 values,
     * so it won't be a problem.
     */
    if (data.split_to) {
        result = (
            <div>
                <span>{ translate('resources.orders.information.multibookings.split_to') }</span>
                {
                    data.split_to.map(function (booking) {
                        return (
                            <Link key={ booking } to={ `/orders/${ booking }/show` }>
                                { booking }
                            </Link>
                        );
                    }).reduce((prev, curr) => {
                        return [
                            prev,
                            ', ',
                            curr,
                        ];
                    })
                }
            </div>
        );
    }

    return (
        <ErrorMessageField>
            { result }
        </ErrorMessageField>
    );
};

MultiBookingInformation.propTypes = {
    data: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(MultiBookingInformation);



// WEBPACK FOOTER //
// ./src/components/notifications/MultiBookingInformationNotification.js